import resolveConfig from 'tailwindcss/resolveConfig.js';
import tailwindConfig from '../tailwind-config/index.js';

const useTailwindConfig = () => resolveConfig(tailwindConfig);
export default useTailwindConfig;
